import React from "react";
import { useState } from "react";

import { useSelector } from "react-redux";
import { selectCountry } from "hyc-store/reducers/countries/countriesReducer";

// controllers
import { EmployeeController } from "controllers";

// pipes
import { titleCasePipe } from "../../shared/pipes";

import { Button } from "shared/components/bulma/button";
import { Modal } from "shared/components/bulma/modal";
import { ModalContent } from "shared/components/bulma/modal";
import { ModalControl } from "shared/components/bulma/modal";
import { SelectRole } from "../../shared/components/SelectRole";

const FormErrorMessage = ({ children }) => {
    if (!children) {
        return null;
    }

    return (
        <article className="message is-danger">
            <div className="message-body">
                {children}
            </div>
        </article>
    );
}

const AddEmployee = ({ onAdd }) => {
    const country = useSelector(selectCountry);
    const fields = ['first_name', 'last_name', 'email'];
    const default_employee = { first_name: '', last_name: '', email: '', role: '', country };

    const [open, setOpen] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [employee, setEmployee] = useState({ ...default_employee });

    const handleOpen = () => {
        setOpen(true);
    }

    const onChange = (event) => {
        const { name, value } = event.target;
        setEmployee({ ...employee, [name]: value });
    }

    const validate = () => {
        const validationFields = [...fields, 'role'];
        for (const field of validationFields) {
            const value = employee[field] ? employee[field].trim() : null;
            if (!value) {
                setSubmitError(`Field ${titleCasePipe.transform(field)} is required.`);
                return false;
            }
        }

        return true;
    }

    const onSubmit = async () => {
        if (!validate()) { return; }

        const e = { ...employee, created_at: +new Date() };
        const payload = { ...e, password: 'hackyourcloset' };
        await EmployeeController.createEmployee(payload);
        resetState();

        if (onAdd) { onAdd({ ...e, new: true }); }
    }

    const resetState = () => {
        setOpen(false);
        setSubmitError('');
        setEmployee({ ...default_employee });
    }

    return (
        <>
            <Button className="is-dark is-outlined" onClick={handleOpen} >
                <span className="icon">
                    <i className="fas fa-user-plus"></i>
                </span>
                <span>Add Employee</span>
            </Button>

            <Modal title="New Employee" isActive={open}>

                <ModalContent>
                    <FormErrorMessage>
                        {submitError}
                    </FormErrorMessage>

                    <div className="columns">
                        <div className="column is-6">
                            {fields.map((field) => (
                                <div key={field} className="field">
                                    <label className="label">{titleCasePipe.transform(field)}</label>
                                    <div className="control">
                                        <input
                                            value={employee[field]}
                                            className="input"
                                            type="text" name={field} onChange={onChange} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="column">
                            <SelectRole label={"Role"}
                                value={employee.role}
                                name="role"
                                onChange={onChange}
                            ></SelectRole>
                        </div>
                    </div>
                </ModalContent>

                <ModalControl>
                    <button className="button is-primary" onClick={onSubmit}>Save</button>
                    <button className="button" onClick={resetState}>Cancel</button>
                </ModalControl>
            </Modal>
        </>
    );
}

export { AddEmployee };
